const Historias = (props) => {
    const { data } = props
    const participante = data;
    return (
        <div className="row justify-content-center">
            {participante.map((historia, index) => {
                return (
                    <div key={index} className=" col-12 col-md-4 pb-4">
                        <div className="">
                            <div className="card text-center mb-4 mx-auto">
                                <div className="circuloParticipante card-img-center mt-4 mx-auto">
                                    <img src={historia.picture} className="mx-auto card-img-center" alt="..." width="100%" />
                                </div>

                                <div className="card-body">
                                    <div className="containerText pb-3">
                                        <p className="card-title text-light lh-base"> {historia.myName} y {historia.iWantToMarryName}</p>
                                    </div>
                                    <p className="card-text textoHistoria text-light">{historia.history}</p>
                                    <button type="button" className="btn btn-vermas" data-bs-toggle="modal" data-bs-target={"#Modal" + index}>
                                        Ver Más
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade" id={"Modal" + index} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog  modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body overflow-auto">
                                        <h1 className="titulosCasate text-center">Historia</h1>
                                        {historia.history}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            })}
        </div>
    )
}
export default Historias;